export default [{
    value: 'zdbx-critical',
    name: '系统关键任务'
  },
  {
    value: 'zdbx-filesystem',
    name: '文件处理任务'
  },
  {
    value: 'wechat-notify',
    name: '微信模版消息'
  },
  {
    value: 'zdbx-default',
    name: '系统普通任务'
  },
  {
    value: 'default',
    name: '系统默认任务'
  }
]


// WEBPACK FOOTER //
// ./src/store/config/queues.js